import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from "@material-ui/core/Select";
import './AddUserModal.scss'
import {CHAINTYPES, storeType, ROLES} from "../../reducers/types";
import {addUserReq} from "../../api/types";
import FormHelperText from "@material-ui/core/FormHelperText";
import {MyInput, Label, MyMenuItem} from "../../components/CustomUIComp/CustomFormElem";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    role: ROLES,
    storeList: storeType[],
    chainType: CHAINTYPES,
    formData: addUserReq,
    handleChange: (object: any) => void,
    errors: { [key: string]: string },
    intl: IntlShape
}

const getRoleListByRole = (role: ROLES) => {
    if (role === ROLES.ADMIN) {
        // 门店管理员
        return [ROLES.ADMIN, ROLES.CASHIER]
    } else if (role === ROLES.SUPER_ADMIN) {
        return [ROLES.ADMIN, ROLES.CASHIER, ROLES.SUPER_ADMIN]
    } else {
        return []
    }
}


function AddUserModal(props: IProps) {
    let {formData, handleChange, errors, intl} = props

    const onChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        handleChange(event.target)
    }

    return (
        <div className="userModalContainer">
            <FormControl className="formControl" fullWidth required error={errors['loginNo'] ? true : false}>
                <Label shrink htmlFor="bootstrap-input">
                    {intl.formatMessage({id: 'email'})}
                </Label>
                <MyInput value={formData.loginNo} onChange={onChange} name="loginNo"/>
                {errors['loginNo'] ?
                    <FormHelperText id="component-error-text">{errors['loginNo']}</FormHelperText> : null}
            </FormControl>
            <FormControl className="formControl" fullWidth required error={errors['password'] ? true : false}>
                <Label shrink htmlFor="bootstrap-input">
                    {intl.formatMessage({id: 'password'})}
                </Label>
                <MyInput type="password" value={formData.password} name="password" onChange={onChange}/>
                {errors['password'] ?
                    <FormHelperText id="component-error-text">{errors['password']}</FormHelperText> : null}
            </FormControl>
            <FormControl className="formControl" fullWidth required error={errors['name'] ? true : false}>
                <Label shrink htmlFor="bootstrap-input">
                    {intl.formatMessage({id: 'name'})}
                </Label>
                <MyInput value={formData.name} name="name" onChange={onChange}/>
                {errors['name'] ?
                    <FormHelperText id="component-error-text">{errors['name']}</FormHelperText> : null}
            </FormControl>
            <FormControl className="formControl" fullWidth error={errors['phoneNo'] ? true : false}>
                <Label shrink htmlFor="bootstrap-input">
                    {intl.formatMessage({id: 'phoneNumber'})}
                </Label>
                <MyInput value={formData.phoneNo} onChange={onChange} name="phoneNo"/>
                {errors['phoneNo'] ?
                    <FormHelperText id="component-error-text">{errors['phoneNo']}</FormHelperText> : null}
            </FormControl>
            <FormControl className="formControl" fullWidth required>
                <Label shrink htmlFor="role-select">
                    {intl.formatMessage({id: 'role'})}
                </Label>
                <Select
                    value={formData.role}
                    onChange={onChange}
                    input={<MyInput id="role-select" name="role"/>}
                >
                    {
                        getRoleListByRole(props.role).map((role) => {
                            return <MyMenuItem value={role}
                                               key={`role-${role}`}>
                                {intl.formatMessage({id: ROLES[role]})}
                            </MyMenuItem>
                        })
                    }
                </Select>
            </FormControl>
            {props.role === ROLES.SUPER_ADMIN && props.chainType === CHAINTYPES.CHAIN_STORE
            && formData.role !== ROLES.SUPER_ADMIN ?
                <FormControl className="formControl" fullWidth>
                    <Label shrink htmlFor="store-select">
                        {intl.formatMessage({id: 'storeName'})}
                    </Label>
                    <Select
                        onChange={onChange}
                        value={formData.storeId}
                        input={<MyInput id="store-select" name="storeId"/>}
                    >
                        <MyMenuItem value={-1}>{intl.formatMessage({id: 'allStore'})}</MyMenuItem>
                        {
                            props.storeList && props.storeList.map((store, i) => {
                                return <MyMenuItem key={store.storeId}
                                                   value={store.storeId}>{store.storeName}</MyMenuItem>
                            })
                        }
                    </Select>
                </FormControl> : null}
        </div>
    );
}

export default injectIntl(AddUserModal)